<template>
  <ViewEntityContainer :entityName="entityName" :identifier="$route.params.partnerCompanyId"
    :getMethod="getPartnerCompanyById" :refreshOnTimestamp="true" :notificationListeners="[srEventKey]"
    :notificationValidator="notificationValidator">
  </ViewEntityContainer>
</template>

<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import SRConst from "@/helpers/Constants/SignalRConstants.js";
import ViewEntityContainer from "@/views/pim/suppliers/ViewEntityContainer.vue";
import EntityNames from "@/helpers/Constants/EntityNames.js";

export default {
  name: "ViewPartnerCompanyContainer",
  components: {
    ViewEntityContainer,
  },
  mixins: [clientAPI],

  data() {
    return {
      entityName: EntityNames.PartnerCompany
    };
  },

  methods: {
    notificationValidator(args, identifier) {
      return args && args.partnerCompanyId == identifier;
    },
  },

  computed: {
    srEventKey() {
      return SRConst.EventKeys.PartnerCompanyChange;
    },
  },

  watch: {},
};
</script>

<style lang="scss" scoped></style>